import ROUTES from '@client-hub/shared/constants/routes'
import { useDispatch } from 'react-redux'
import { useNavigate, Navigate, useLocation } from 'react-router'
import { useSearchParams } from 'react-router-dom'
import { useLazyAccountsProfileQuery } from '@client-hub/store/api/crs/react'
import { useEffect } from 'react'
import { updateCrsToken } from '@client-hub/store/slices/metadata'
import LoadingScreen from '@client-hub/shared/react/components/LoadingScreen'
import { useNotifications } from '@client-hub/shared/react/hooks/notifications'

const SSO = () => {
  const notify = useNotifications()
  const location = useLocation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const error = searchParams.get('error')
  const ssoRedirect = searchParams.get('sso_redirect')
  const token = searchParams.get('token') as string
  const dispatch = useDispatch()
  const locationState = location.state as { from: Location } | undefined
  const [getAccountProfile, { isError, isSuccess }] = useLazyAccountsProfileQuery()

  useEffect(() => {
    if (error) notify({ message: error, variant: 'error' })
  }, [error])

  useEffect(() => {
    if (token && ssoRedirect) {
      dispatch(updateCrsToken(token))
      getAccountProfile()
    }
  }, [token])

  useEffect(() => {
    if (isSuccess) {
      navigate(locationState?.from || ROUTES.BASE)
    } else if (isError) {
      navigate(ROUTES.LOGIN.BASE)
    }
  }, [isError, isSuccess])

  return error || !token || !ssoRedirect ? (
    <Navigate to={ROUTES.LOGIN.BASE} state={{ ssoError: error }} />
  ) : (
    <LoadingScreen />
  )
}

export default SSO
